import { Core } from 'create-es6-js';

const core = {
  EventDispatcher: Core.EventDispatcher,
  Event: Core.Event,
  ErrorEvent: Core.ErrorEvent,
  MouseEvent: Core.MouseEvent,
  ProgressEvent: Core.ProgressEvent,
  BrowserDetect: Core.BrowserDetect,
  Ticker: Core.Ticker,
  Touch: Core.Touch,
  UID: Core.UID,
  extend: Core.extend,
  indexOf: Core.indexOf,
  promote: Core.promote,
};

export default core;




// WEBPACK FOOTER //
// ./Core/index.js